import { render, staticRenderFns } from "./ads-postpaid-bank-transfer.vue?vue&type=template&id=1d685cea&scoped=true"
import script from "./ads-postpaid-bank-transfer.vue?vue&type=script&lang=js"
export * from "./ads-postpaid-bank-transfer.vue?vue&type=script&lang=js"
import style0 from "./ads-postpaid-bank-transfer.vue?vue&type=style&index=0&id=1d685cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d685cea",
  null
  
)

export default component.exports